<h3 class="text-center" style="color: #5A1727"> Distintivo Medioambiental</h3>
<mat-horizontal-stepper linear #stepper>
  <mat-step [stepControl]="datosVehiculos" [editable]="isEditable">
    <ng-template matStepLabel>Vehículo </ng-template>
    <form [formGroup]="datosVehiculos" autocomplete="off" (ngSubmit)="siguiente()">
      <h3 class="text-left" style="color: #5A1727">Datos Vehículos</h3>
      <hr>
      <div class="text-center">
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
          <mat-label>Matrícula</mat-label>
          <input matInput matNativeControl type="text" maxlength="10" [class.is-invalid]="matriculaNoValido"  formControlName="matricula" (input)="getVehiculo()">
          <small *ngIf="matriculaNoValido">
            La matrícula es <strong>requerida</strong>
          </small>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
          <mat-label>Nº Bastidor (E)</mat-label>
          <input matInput matNativeControl type="text" maxlength="30" [class.is-invalid]="bastidorNoValido"
                 formControlName="bastidor" onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)" maxlength="17">
          <small *ngIf="bastidorNoValido">
            El numero de Bastidor es <strong>requerido</strong>
          </small>
        </mat-form-field>
      </div>
      <div class="logo" *ngIf="activar">
        <img mat-card-md-image class="distintivo" [src] = "distintivo">
      </div>
      <div class="text-center mt-3" style="margin-bottom: 3rem">
        <button mat-button type="submit" class="btn-secondary" matStepperNext>Siguiente</button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="(datosCliente | async)" [editable]="isEditable">
    <ng-template matStepLabel>Comprador</ng-template>
    <app-cliente #clienteComprador (datoCliente)="siguiente2($event)"></app-cliente>
  </mat-step>

  <mat-step [stepControl]="documentos" [editable]="isEditable">
    <ng-template matStepLabel>Documentos</ng-template>
    <app-documentos [datoTramite]="DatoCliente"></app-documentos>
  </mat-step>

</mat-horizontal-stepper>
